"use client";

import type { ReactNode } from "react";
import { MotionConfig } from "framer-motion";

/**
 * framer-motion's MotionConfig for every page in the locale layout: prefers-reduced-motion is
 * honoured for every animation site-wide. Nothing on the landers' first screen animates with
 * framer-motion (the FAQ is CSS, the cart drawer is its own chunk), so the animation code comes
 * with the components that use it.
 */
export function MotionProvider({ children }: { children: ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
